import {Directive, ElementRef, Input, effect} from '@angular/core';
import {Store} from "@ngrx/store";
import {toSignal} from "@angular/core/rxjs-interop";
import {ApiModules, ApiOperations, OrganisationUserRoles} from "@qid/core";
import {OrganisationUser} from '../models/organisation-user.model';
import {selectActiveOrganisationUser} from "../+state/organisation-user.selectors";


@Directive({
  standalone: true,
  selector: '[permissionModule]'
})
export class PermissionDirective {

  @Input() permissionModule: ApiModules;
  @Input() permissionOperation: ApiOperations;

  private orgUser = toSignal(this.store.select(selectActiveOrganisationUser));

  constructor(
    private el: ElementRef,
    private store: Store
  ) {
    effect(() => {
      const user = this.orgUser();

      // Guard: wait for inputs to be set
      if (!this.permissionModule || !this.permissionOperation || user == null) {
        return;
      }

      // Admins and SuperAdmins have access to everything
      if (+user.role <= +OrganisationUserRoles.ADMIN) {
        this.el.nativeElement.style.display = '';
        return;
      }

      // Check specific permission for Editors and Viewers
      const permission = this.permissionModule + '_' + this.permissionOperation;
      if (user.permissions.indexOf(permission) < 0) {
        this.el.nativeElement.style.display = 'none';
      } else {
        this.el.nativeElement.style.display = '';
      }
    });
  }

  public static hasPermission(orgUser: OrganisationUser, module: ApiModules, operation: ApiOperations | string) {
    if (+orgUser?.role <= +OrganisationUserRoles.ADMIN) {
      return true
    }
    return orgUser?.permissions?.indexOf(module + "_" + operation) > -1;
  }
}
